import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';

const sanitizeFileName = (value, fallback = 'Documento') => {
    const sanitizedName = String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-zA-Z0-9 ._()-]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/^[. ]+|[. ]+$/g, '')
        .substring(0, 180)
        .trim();

    if (!sanitizedName) return fallback;

    return /^(con|prn|aux|nul|com[1-9]|lpt[1-9])$/i.test(sanitizedName)
        ? `${sanitizedName}_`
        : sanitizedName;
};

const sanitizeWorksheetName = (value, fallback = 'Hoja 1') => {
    return sanitizeFileName(value, fallback)
        .replace(/\s+/g, ' ')
        .trim()
        .substring(0, 31) || fallback;
};

export const printToExcel = (data, fileName, columnsToSum = null, docTitle = "", includeHeader = true, includeFooter = true, subtitle = null, exportOptions = {}) => {
    const safeFileName = sanitizeFileName(fileName, 'Documento');
    const safeWorksheetName = sanitizeWorksheetName(fileName, 'Reporte');
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(safeWorksheetName);
    const initialRow = includeHeader ? 4 : 1;
    const exportConfig = {
        component: data.component,
        worksheet,
        topLeftCell: { row: initialRow, column: 1 },
    };

    if (typeof exportOptions.customizeCell === 'function') {
        exportConfig.customizeCell = exportOptions.customizeCell;
    }

    exportDataGrid(exportConfig).then((cellRange) => {
        // header
        if (includeHeader) {
            const headerRow = worksheet.getRow(2);
            headerRow.height = 30;
            worksheet.mergeCells(2, 1, 2, 8);

            headerRow.getCell(1).value = docTitle || fileName
            headerRow.getCell(1).font = { name: 'Segoe UI Light', size: 22 };
            headerRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };

            if (subtitle) {
                const subtitleRow = worksheet.getRow(3);
                subtitleRow.height = 20;
                worksheet.mergeCells(3, 1, 3, 8);
                subtitleRow.getCell(1).value = subtitle;
                subtitleRow.getCell(1).font = { name: 'Segoe UI Light', size: 12 };
                subtitleRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
            }
        }
        // footer
        if (includeFooter) {
            const footerRowIndex = cellRange.to.row + 2;
            const footerRow = worksheet.getRow(footerRowIndex);
            worksheet.mergeCells(footerRowIndex, 1, footerRowIndex, 8);

            footerRow.getCell(1).value = '-';
            footerRow.getCell(1).font = { color: { argb: 'BFBFBF' }, italic: true };
            footerRow.getCell(1).alignment = { horizontal: 'right' };
        }
        
        
        if(columnsToSum != null){
            const sumRowName = worksheet.getRow(cellRange.to.row + 1);
            sumRowName.getCell(1).value = 'Sumatoria';
        

            const Currency = JSON.parse(localStorage.getItem('branch')).Currency;
            columnsToSum.forEach(columnName => {
                // Find the index of the column by name in the header row
                const columnIndex = worksheet.getRow(4).values.findIndex(cell => cell === columnName);
                
              
                if (columnIndex === -1) {
                    return;
                }
                // Get all values for the columns 
                let columnValues = worksheet.getColumn(columnIndex).values;

                let numberValues = []
                
                columnValues.forEach(value => {
                    let number = 0

                    if (typeof value === 'string') {
                        if (value.includes(Currency)) {
                            let stringValue = value.replace(Currency, '');
                            
                            if (stringValue.includes('-')) {
                                stringValue = stringValue.replace('-', '');
                                stringValue = stringValue.replace(',', '');
                            }

                            stringValue.trim()

                            number = parseFloat(stringValue)

                            if (!isNaN(number)) {
                                numberValues.push(number)
                            }
                        }
                    } else if (typeof value === 'number') {
                        numberValues.push(value)
                    }
                });

                let sumValue = 0;


                numberValues.forEach((value) => {
                    sumValue += value;
                });


                sumRowName.getCell(columnIndex).value = `${Currency}${sumValue.toFixed(2)}`;                
            });
        }
/*  
        if (sum && sum.length > 0) {
            const sumRowIndex = cellRange.to.row + 3; // Row after the footer
            sum.forEach(columnIndex => {
                let sumValue = 0;
                for (let i = 4; i <= cellRange.to.row; i++) {
                    const cellValue = worksheet.getRow(i).getCell(columnIndex).value;
                    sumValue += (typeof cellValue === 'number' ? cellValue : 0);
                }
                const sumCell = worksheet.getRow(sumRowIndex).getCell(columnIndex);
                sumCell.value = sumValue;
                sumCell.font = { bold: true };
            });
        } */

    }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), safeFileName + '.xlsx');
        });
    });

};
